/** 시설 현장 비밀번호 로그인 JWT (관리자 JWT와 별도) */

export const POOL_SITE_TOKEN_KEY = 'pool_site_token';
export const POOL_SITE_POOL_ID_KEY = 'pool_site_pool_id';

export function getStoredPoolSiteToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(POOL_SITE_TOKEN_KEY);
}

export function getStoredPoolSitePoolId(): number | null {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(POOL_SITE_POOL_ID_KEY);
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function setPoolSiteSession(accessToken: string, poolId: number | string): void {
  localStorage.setItem(POOL_SITE_TOKEN_KEY, accessToken);
  localStorage.setItem(POOL_SITE_POOL_ID_KEY, String(poolId));
}

export function clearPoolSiteSession(): void {
  localStorage.removeItem(POOL_SITE_TOKEN_KEY);
  localStorage.removeItem(POOL_SITE_POOL_ID_KEY);
}

export function getBearerTokenForApi(): string | null {
  const admin = localStorage.getItem('token') || localStorage.getItem('auth_token');
  if (admin) return admin;
  return getStoredPoolSiteToken();
}
